<template>
  <div class="bg-primary-orange">
    <div class="flex justify-between items-center text-gray-800 z-10 px-6 h-24">
      <h1 class="text-3xl font-heading">Recipes</h1>
      <button type="button" @click="createNewRecipe" class="p-2 rounded-full active:bg-orange-400">
        <svg
          class="stroke-current h-6 w-6"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          viewBox="0 0 24 24"
        >
          <path d="M12 5v14M5 12h14" />
        </svg>
      </button>
    </div>
    <div class="flex-1 overflow-y-scroll bg-gray-100 py-6 px-3 rounded-t-xl">
      <template v-for="recipe in $store.state.allRecipes">
        <div
          :key="recipe.id"
          class="py-2 px-3 bg-white active:bg-gray-300 shadow rounded-lg my-2"
          @click="openRecipe(recipe)"
        >
          <h2 class="text-xl">{{ recipe.title }}</h2>
          <div class="custom-elipsis">{{ recipe.description }}</div>
        </div>
      </template>
      <div
        class="h-full flex justify-center items-center"
        v-if="$store.state.allRecipes.length == 0"
      >
        <div class="text-center">
          <svg class="mx-auto text-gray-800 fill-current h-24 w-24 mb-2" viewBox="0 0 32 32">
            <path
              d="M9.063 19.5c-0.813 0-1.563-0.313-2.125-0.875l-6.75-6.75c-0.125-0.125-0.188-0.313-0.188-0.5s0.063-0.313 0.188-0.438l8.188-8.188c0.25-0.25 0.688-0.25 0.938 0l6.75 6.75c1.188 1.125 1.188 3 0 4.188l-4.938 4.938c-0.563 0.563-1.313 0.875-2.063 0.875zM1.625 11.375l6.25 6.313c0.625 0.625 1.688 0.625 2.313 0l4.938-4.938c0.625-0.625 0.625-1.688 0-2.313l-6.25-6.313zM21.813 25.063c-0.125 0-0.313-0.125-0.438-0.25l-8.688-8.688c-0.313-0.25-0.313-0.688 0-0.938 0.25-0.25 0.688-0.25 0.938 0l8.688 8.688c0.25 0.25 0.25 0.688 0 0.938-0.125 0.125-0.313 0.25-0.5 0.25zM26.25 29.813c-0.25 0-0.5-0.125-0.688-0.313l-3.75-3.75c-0.375-0.375-0.375-1 0-1.438 0.375-0.375 1-0.375 1.375 0l3.75 3.75c0.438 0.438 0.438 1.063 0 1.438-0.188 0.188-0.438 0.313-0.688 0.313zM12.875 25.063c-0.125 0-0.313-0.125-0.438-0.25-0.25-0.25-0.25-0.688 0-0.938l8.688-8.688c0.25-0.25 0.688-0.25 0.938 0s0.25 0.688 0 0.938l-8.688 8.688c-0.125 0.125-0.313 0.25-0.5 0.25zM8.5 29.813c-0.313 0-0.563-0.125-0.75-0.313-0.375-0.375-0.375-1 0-1.438l3.75-3.75c0.438-0.375 1.063-0.375 1.438 0 0.375 0.438 0.375 1.063 0 1.438l-3.75 3.75c-0.188 0.188-0.438 0.313-0.688 0.313zM25 17.688c-1.5 0-2.875-0.563-3.875-1.563-2.25-2.25-2.063-6.188 0.563-8.75 1.313-1.313 3.063-2.125 4.875-2.125 1.5 0 2.875 0.563 3.875 1.563 1.125 1.125 1.688 2.688 1.563 4.313-0.125 1.688-0.875 3.25-2.125 4.5-1.313 1.313-3.125 2.063-4.875 2.063zM26.563 6.625c-1.438 0-2.875 0.625-3.938 1.688-2.063 2.063-2.313 5.125-0.563 6.875 0.75 0.75 1.813 1.188 2.938 1.188 1.438 0 2.875-0.625 3.938-1.688 1-1 1.625-2.313 1.688-3.625 0.125-1.313-0.313-2.438-1.125-3.313-0.75-0.75-1.813-1.125-2.938-1.125zM25.063 15c-0.188 0-0.375-0.063-0.5-0.188-0.25-0.313-0.25-0.688 0-1l3.563-3.5c0.25-0.313 0.688-0.313 0.938 0 0.25 0.25 0.25 0.625 0 0.938l-3.563 3.563c-0.125 0.125-0.25 0.188-0.438 0.188zM22.938 12.875c-0.125 0-0.313-0.063-0.438-0.188-0.25-0.25-0.25-0.688 0-0.938l3.563-3.563c0.25-0.25 0.688-0.25 0.938 0s0.25 0.688 0 0.938l-3.563 3.563c-0.125 0.125-0.313 0.188-0.5 0.188z"
            />
          </svg>
          <h2 class="text-2xl font-heading">You have no recipes</h2>
          <p>Add some with the + button</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "home",
  mounted() {
    this.$store.dispatch("setLoading", false);
  },
  methods: {
    createNewRecipe: function() {
      this.$router.push({ name: "create" });
    },
    openRecipe: function(recipe) {
      this.$router.push({ name: "recipe", params: { recipeId: recipe.id } });
    }
  }
};
</script>

<style scoped>
.custom-elipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2; /* number of lines to show */
  -webkit-box-orient: vertical;
}
</style>